module.exports = __webpack_public_path__ + "img/search.5bd60d6d.svg";